export interface CompanyInterface {
  id: string;
  name: string;
  address: string;
  phoneNumber: string;
  logo?: any;
  slogan: string;
}

export class Company implements CompanyInterface {
  id: string;
  name: string;
  address: string;
  phoneNumber: string;
  slogan: string;
  logo: any;

  constructor(data: Partial<CompanyInterface>) {
    this.id = data.id!;
    this.name = data.name!;
    this.address = data.address!;
    this.phoneNumber = data.phoneNumber!;
    this.slogan = data.slogan!;
    this.logo = data.logo || null;
  }

  toJson(): CompanyInterface {
    return {
      id: this.id,
      name: this.name,
      address: this.address,
      phoneNumber: this.phoneNumber,
      slogan: this.slogan,
      logo: this.logo,
    };
  }
}
